import { Outlet } from 'react-router'
import { HeaderMenu } from './HeaderMenu.tsx'
import { FooterLinks } from './FooterLinks.tsx'
import { Facebook, Twitter, Instagram, Youtube, Github, Linkedin, Home, BarChart3, FileText, FolderOpen, Users, Database, TrendingUp, Clock, Map, Settings, Heart, Building2, X, Info, MapPin, BookOpen } from 'lucide-react'

export default function Layout() {
  // Professional corporate logo for Aurora
  const logoSrc = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgwIiBoZWlnaHQ9IjUwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxyZWN0IHdpZHRoPSIxODAiIGhlaWdodD0iNTAiIGZpbGw9IiMyNTYzZWIiLz48dGV4dCB4PSI5MCIgeT0iMzIiIGZvbnQtZmFtaWx5PSJSb2JvdG8iIGZvbnQtc2l6ZT0iMTgiIGZvbnQtd2VpZ2h0PSI3MDAiIGZpbGw9IndoaXRlIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIj5UQVRBREVTQTwvdGV4dD48L3N2Zz4="

  // Enhanced menu structure based on actual backend data and functionality
  const corporateMenuItems = [
    {
      title: "Dashboard",
      href: "/",
      description: "Overview utama dengan statistik dan ringkasan",
      icon: Home
    },
    {
      title: "Data & Statistik",
      icon: BarChart3,
      children: [
        {
          title: "Dashboard Statistik",
          href: "/statistics",
          description: "Analisis mendalam data penduduk",
          icon: TrendingUp
        },
        {
          title: "Data Kesehatan",
          href: "/health-statistics",
          description: "Informasi kesehatan dan layanan medis",
          icon: Heart
        }
      ]
    },
    {
      title: "Proyek & Kegiatan",
      icon: FolderOpen,
      children: [
        {
          title: "Semua Proyek",
          href: "/projects",
          description: "Daftar lengkap proyek pembangunan",
          icon: FolderOpen
        },
        {
          title: "Laporan Proyek",
          href: "/reports",
          description: "Business Intelligence Reports & laporan progress proyek",
          icon: BarChart3
        }
      ]
    },
    {
      title: "Berita",
      href: "/news",
      description: "Berita terbaru dan pengumuman",
      icon: FileText
    },
    {
      title: "Profil Desa",
      icon: Building2,
      children: [
        {
          title: "Tentang",
          href: "/desa",
          description: "Informasi desa dan struktur pemerintahan",
          icon: Info
        },
        {
          title: "Lokasi",
          href: "/desa/lokasi",
          description: "Peta lokasi kantor desa",
          icon: MapPin
        }
      ]
    },
    {
      title: "Buku Tamu",
      href: "/buku-tamu",
      description: "Isi buku tamu digital",
      icon: BookOpen
    }
    // {
    //   title: "Peta & Wilayah",
    //   href: "/map",
    //   description: "Peta interaktif wilayah desa",
    //   icon: Map
    // }
  ]

  // Enhanced footer structure matching the new navigation
  const corporateFooterColumns = [
    {
      title: "Data & Statistik",
      links: [
        { title: "Dashboard Statistik", href: "/statistics" },
        { title: "Data Kesehatan", href: "/health-statistics" }
      ]
    },
    {
      title: "Proyek & Kegiatan",
      links: [
        { title: "Semua Proyek", href: "/projects" },
        { title: "Laporan Proyek", href: "/reports" }
      ]
    },
    {
      title: "Berita & Publikasi",
      links: [
        { title: "Semua Berita", href: "/news" }
      ]
    },
    {
      title: "Informasi Desa",
      links: [
        { title: "Tentang", href: "/desa" },
        { title: "Lokasi", href: "/desa/lokasi" }
      ]
    },
    {
      title: "Proyek & Kegiatan",
      links: [
        { title: "Semua Proyek", href: "/projects" },
        { title: "Laporan Proyek", href: "/reports" }
      ]
    }
  ]

  // Enhanced company info for Tatadesa
  const companyInfo = {
    name: "Tatadesa",
    logo: "/images/tatadesa/logo-desa.svg",
    description:
      "Sistem Informasi Desa Tatadesa - Platform digital terintegrasi untuk pengelolaan data kependudukan, proyek pembangunan, dan layanan publik desa modern.",
    copyright: "© 2025 Tatadesa. Hak Cipta Dilindungi Undang-Undang.",
    socialLinks: [
      // { name: "Facebook", href: "https://facebook.com/tatadesa", icon: <Facebook size={20} /> },
      // { name: "Instagram", href: "https://instagram.com/tatadesa", icon: <Instagram size={20} /> },
      // { name: "Twitter", href: "https://x.com/tatadesa", icon: <X size={20} /> },
      // { name: "Youtube", href: "https://www.youtube.com/@tatadesa", icon: <Youtube size={20} /> },
    ],
  }

  return (
    <div className="aurora-corporate min-h-screen flex flex-col bg-gradient-to-br from-corporate-gray-50 to-white">
      {/* Professional Corporate Header */}
      <HeaderMenu logoSrc={logoSrc} menuItems={corporateMenuItems} />

      {/* Main Content Area with Corporate Styling */}
      <main className="flex-1 bg-white">
        <div className="border-t border-corporate-gray-100">
          <Outlet />
        </div>
      </main>

      {/* Professional Corporate Footer */}
      <FooterLinks columns={corporateFooterColumns} companyInfo={companyInfo} />
    </div>
  )
}
